import VImageUpload from './index.vue';

export default {
  install: (Vue) => Vue.component('VImageUpload', VImageUpload),
};
